import * as Sentry from '@sentry/react';

// Crash & error monitoring — mandatory on every SynthOS build.
// Guarded so an empty DSN is a safe no-op.
export function initSentry() {
  const dsn = __SENTRY_DSN__;
  if (!dsn) return;
  try {
    Sentry.init({
      dsn,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.15,
      environment: import.meta.env.MODE,
    });
  } catch {
    // never let monitoring init break the app
  }
}

export { Sentry };
